import { OrderCancellation } from "lib/types/generated/graphql-types"
import { OrderOperations } from "./OrderOperations"

export class Cancellation extends OrderOperations {
  constructor(cancellation: OrderCancellation[]) {
    super(cancellation)
  }

  public completedCancellations(): OrderCancellation[] {
    return this.completedList() as OrderCancellation[]
  }

  public orderCancelled(orderId: string): OrderCancellation | undefined {
    return this.completedCancellations().find((cancellation) => cancellation.orderId === orderId)
  }

  public getPendingCancellation(): OrderCancellation {
    const pendingList = this.pendingList() as OrderCancellation[]
    return pendingList[0]
  }

  public getFailedCancellation(): OrderCancellation {
    const failedList = this.failedList() as OrderCancellation[]
    return failedList[0]
  }

  public getOngoingCancellation(): OrderCancellation {
    const ongoingList = this.onGoingList() as OrderCancellation[]
    return ongoingList[0]
  }
}
